import * as Yup from 'yup';

import { Strings } from '@app/constants';

export const addOfferLetterSchema = Yup.object()
  .shape({
    fullName: Yup.string().trim().required(Strings.validation.fieldRequired(Strings.field.name)),
    position: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.position)),
    monthlySalary: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.monthlySalary)),
    contraction: Yup.string().required(Strings.validation.fieldRequired(Strings.field.contraction)),
    joiningDate: Yup.string().required(Strings.validation.fieldRequired(Strings.field.joinDate)),
  })
  .required();
export const addCompensationSchema = Yup.object()
  .shape({
    name: Yup.string().trim().required(Strings.validation.fieldRequired(Strings.field.name)),
    revisedSalary: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.revisedSalary)),
    monthlySalary: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.monthlySalary)),
    quarterlyAllowance: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.quarterlyAllowance)),
    date: Yup.string().trim().required(Strings.validation.fieldRequired(Strings.field.date)),
  })
  .required();
